// Shared by every layer that writes words.

/** Eases each item's opacity toward shown or hidden, so nothing pops. */
export class Fades {
  private readonly values = new Map<string, number>();
  private moving = false;
  begin(): void {
    this.moving = false;
  }
  get(id: string, shown: boolean, k: number): number {
    const v = this.values.get(id) ?? 0;
    const target = shown ? 1 : 0;
    let next = v + (target - v) * k;
    if (Math.abs(next - target) < 0.01) next = target;
    else this.moving = true;
    if (next === 0) this.values.delete(id);
    else this.values.set(id, next);
    return next;
  }
  get busy(): boolean {
    return this.moving;
  }
}
